module.exports = __webpack_public_path__ + "img/clipboard-data.d29a195c.svg";